import React, { useState } from "react";
import { Box, PrimaryButton, SecondaryButton, Text } from "components";
import Drawer from "components/smaltOverwritten/Drawer";
import useWindowDimensions from "hooks/windowDimensions";

const LONG_MESSAGE = (
  <Box
    direction="column"
    gap="m"
    as="section"
    aria-label="Data protection details"
  >
    <Text fontWeight="bold" fontSize="m" mB="xs">
      Purpose:
    </Text>
    <Text fontSize="m" mB="xs">
      Your document data is used only to verify your eligibility to use Smart
      Gates with the competent border authority (GDRFA).
    </Text>
    <Text fontWeight="bold" fontSize="m" mB="xs">
      What we collect:
    </Text>
    <Text fontSize="m" mB="xs">
      – Document image (e.g. passport page)
      <br />
      <br />– Limited technical information (device type, timestamp, processing
      duration)
    </Text>
    <Text fontWeight="bold" fontSize="m" mB="xs">
      How we process your data:
    </Text>
    <Text fontSize="m" mB="xs">
      – Data is encrypted and transmitted securely to the validation authority
      <br />
      <br />
      – AirportLabs does not store or retain any personal data after the
      validation completes
      <br />
      <br />– Data is not used for analytics, training, or any other secondary
      purpose
    </Text>
    <Text fontWeight="bold" fontSize="m" mB="xs">
      Legal basis:
    </Text>
    <Text fontSize="m" mB="xs">
      Processing is based on your explicit consent and is necessary for
      performing the validation you request.
    </Text>
    <Text fontWeight="bold" fontSize="m" mB="xs">
      Your rights:
    </Text>
    <Text fontSize="m" mB="xs">
      You can withdraw consent at any time.
      <br />
      <br />
      You can request access, correction, or deletion of your data through
      AirportLabs.
      <br />
      <br />
      Refusing consent will only disable the Smart Gates feature; all other app
      features remain available.
    </Text>
    <Text fontWeight="bold" fontSize="m" mB="xs">
      Data security:
    </Text>
    <Text fontSize="m" mB="xs">
      – Encrypted transmission during processing
      <br />
      <br />– No data retention by AirportLabs
    </Text>
    <Text fontSize="m" mB="xs">
      <b>Controller:</b> AirportLabs
      <br />
      <br />
      <b>Contact: </b>
      <a href="mailto:support@airportlabs.com">support@airportlabs.com</a>
    </Text>
  </Box>
);

const PreCameraDrawer = ({ isOpen, onContinue, onCancel }) => {
  const { height } = useWindowDimensions();
  const [showDetails, setShowDetails] = useState(false);

  return (
    <Drawer isOpen={isOpen} translationAmount={0} minimumContentHeight={height}>
      <Box
        d="flex"
        direction="column"
        alignItems="center"
        justifyContent="center"
        flex="1"
        gap="l"
        pH="l"
        pV="xl"
        style={{ maxWidth: 480, margin: "0 auto" }}
      >
        <Text fontSize="l" textAlign="center" fontWeight="bold" mB="m">
          We protect your privacy.
        </Text>
        <Text fontSize="m" textAlign="left" mB="m">
          Your document is processed securely and transmitted only for
          validation with the relevant border authority to verify eligibility
          for Smart Gates.
          <br />
          <br />
          No personal data is stored after processing.
        </Text>
        <Text
          as="button"
          type="button"
          fontSize="m"
          color="primary"
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            textDecoration: "underline",
          }}
          aria-expanded={showDetails}
          aria-controls="learn-more-details"
          onClick={() => setShowDetails((v) => !v)}
          mB="m"
        >
          {showDetails ? "Hide details" : "Learn more"}
        </Text>
        {showDetails && (
          <Box id="learn-more-details" w="100%" mB="l">
            {LONG_MESSAGE}
          </Box>
        )}
        <Box
          d="flex"
          gap="base"
          w="100%"
          justifyContent="center"
          style={{ paddingBottom: "230px" }}
        >
          <SecondaryButton onClick={onCancel} style={{ minWidth: 120 }}>
            <Text fontSize="m">Decline</Text>
          </SecondaryButton>
          <PrimaryButton onClick={onContinue} style={{ minWidth: 160 }}>
            <Text fontSize="m">Accept & Continue</Text>
          </PrimaryButton>
        </Box>
      </Box>
    </Drawer>
  );
};

export default PreCameraDrawer;
